// function init(elem, options) {
//     elem.addClass("countdownHolder");

//     // Создаем разметку внутри контейнера
//     $.each(["Days", "Hours", "Minutes"], function (i) {
//         $('<span class="count' + this + '">')
//             .html(
//                 '<span class="position">\
// 				<span class="digit static">0</span>\
// 			</span>\
// 			<span class="position">\
// 				<span class="digit static">0</span>\
// 			</span>'
//             )
//             .appendTo(elem);

//         if (this === "Days") {
//             elem.append(
//                 '<span class="countDiv countDiv' + i + '">Дней -</span>'
//             );
//         }

//         if (this === "Hours") {
//             elem.append(
//                 '<span class="countDiv countDiv' + i + '">Часов -</span>'
//             );
//         }

//         if (this === "Minutes") {
//             elem.append(
//                 '<span class="countDiv countDiv' + i + '">Минут</span>'
//             );
//         }

//         if (this != "Seconds") {
//             elem.append('<span class="countDiv countDiv' + i + '"></span>');
//         }
//     });
// }

// // Создаем анимированный переход между двумя цифрами
// function switchDigit(position, number) {
//     var digit = position.find(".digit");

//     if (digit.is(":animated")) {
//         return false;
//     }

//     if (position.data("digit") == number) {
//         // Мы уже вывели данную цифру
//         return false;
//     }

//     position.data("digit", number);

//     var replacement = $("<span>", {
//         class: "digit",
//         css: {
//             top: "-2.1em",
//             opacity: 0,
//         },
//         html: number,
//     });

//     // Класс .static добавляется, когда завершается анимация.
//     // Выполнение идет более плавно.

//     digit
//         .before(replacement)
//         .removeClass("static")
//         .animate({ top: "2.5em", opacity: 0 }, "fast", function () {
//             digit.remove();
//         });

//     replacement.delay(100).animate({ top: 0, opacity: 1 }, "fast", function () {
//         replacement.addClass("static");
//     });
// }

// (function ($) {
//     // Количество секунд в каждом временном отрезке
//     var days = 24 * 60 * 60,
//         hours = 60 * 60,
//         minutes = 60;

//     // Создаем плагин
//     $.fn.countdown = function (prop) {
//         var options = $.extend(
//             {
//                 callback: function () {},
//                 timestamp: 0,
//             },
//             prop
//         );

//         var left, d, h, m, s, positions;

//         // инициализируем плагин
//         init(this, options);

//         positions = this.find(".position");

//         (function tick() {
//             // Осталось времени
//             left = Math.floor((options.timestamp - new Date()) / 1000);

//             if (left < 0) {
//                 left = 0;
//             }

//             // Осталось дней
//             d = Math.floor(left / days);
//             updateDuo(0, 1, d);
//             left -= d * days;

//             // Осталось часов
//             h = Math.floor(left / hours);
//             updateDuo(2, 3, h);
//             left -= h * hours;

//             // Осталось минут
//             m = Math.floor(left / minutes);
//             updateDuo(4, 5, m);
//             left -= m * minutes;

//             // Осталось секунд
//             s = left;
//             updateDuo(6, 7, s);

//             // Вызываем возвратную функцию пользователя
//             options.callback(d, h, m, s);

//             // Планируем следующий вызов данной функции через 1 секунду
//             setTimeout(tick, 1000);
//         })();

//         // Данная функция обновляет две цифровые позиции за один раз
//         function updateDuo(minor, major, value) {
//             switchDigit(positions.eq(minor), Math.floor(value / 10) % 10);
//             switchDigit(positions.eq(major), value % 10);
//         }

//         return this;
//     };

//     // Здесь размещаются две вспомогательные функции
// })(jQuery);

// $(function () {
//     var note = $("#note"),
//         ts = new Date(2023, 11, 22),
//         newYear = false;

//     if (new Date() > ts) {
//         // Задаем точку отсчета для примера. Пусть будет очередной Новый год или дата через 10 дней.
//         // Обратите внимание на *1000 в конце - время должно задаваться в миллисекундах
//         ts = new Date().getTime() + 15 * 24 * 60 * 60 * 1000;
//         newYear = false;
//     }

//     $("#countdown").countdown({
//         timestamp: ts,
//         callback: function (days, hours, minutes) {
//             var message = "";

//             message += "Дней: " + days + ", ";
//             message += "часов: " + hours + ", ";
//             message += "минут: " + minutes;

//             if (newYear) {
//                 message += "осталось до Нового года!";
//             } else {
//                 message += "осталось до момента через 10 дней!";
//             }

//             // note.html(message);
//         },
//     });
// });

function timerEvent() {
    const $event = $(".event-block");
    const eventDate = $event.data("start-time");
    const $timer = $(".event-block__timer");
    const $text = $(".event-block__text");
    $text.html($event.data("start-text"));

    function updateTimer() {
        const t = getTimeRemaining(eventDate);

        if (t.total <= 0) {
            $(".event-img").addClass("_visible");
        } else {
            $timer.html(
                `${t.days} дней ${("0" + t.hours).slice(-2)} часов ${(
                    "0" + t.minutes
                ).slice(-2)} минут`
            );
            setTimeout(updateTimer, 1000);
        }
    }
    updateTimer();

    function getTimeRemaining(endtime) {
        const t = Date.parse(endtime) - Date.parse(new Date());
        const seconds = Math.floor((t / 1000) % 60);
        const minutes = Math.floor((t / 1000 / 60) % 60);
        const hours = Math.floor((t / (1000 * 60 * 60)) % 24);
        const days = Math.floor(t / (1000 * 60 * 60 * 24));
        return {
            total: t,
            days: days,
            hours: hours,
            minutes: minutes,
            seconds: seconds,
        };
    }
}

// timerEvent();



// WEBPACK FOOTER //
// ./_src/js/modules/TimerEvent.js